'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularToastr = require('angular-toastr');

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _Components = require('./Components');

var _Components2 = _interopRequireDefault(_Components);

var _services = require('./services');

var _services2 = _interopRequireDefault(_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonModule = _angular2.default.module('app.common', [_Components2.default.name, _services2.default.name, _angularToastr2.default]);

exports.default = commonModule;


/** WEBPACK FOOTER **
 ** ./client/app/common/common.js
 **/